// Initialize DataDog RUM Monitoring
import 'lib/browserMonitoring/initialize'

import './shoplist-app/rewards-terms-and-conditions/bundle.scss'
import 'marketing-components/dist/components/organisms/header/less/header.less'
import 'marketing-components/dist/components/organisms/footer/less/footer.less'
import { initA11yLinting } from 'lib/initA11yLinting'
// @ts-ignore
__webpack_public_path__ = window.webpackPublicPath
window.addEventListener('DOMContentLoaded', () => {
  require('./render-rewardsTermsAndConditions.tsx')
})

initA11yLinting()
